import { defaultValueCamerasFilterIProps } from "~/entity/Ivideon";

export const defaultValueCamerasFilter: defaultValueCamerasFilterIProps = {
  zoneType: null,
  cameraName: "",
  cameraIvideonId: "",
  action: null,
  userName: "",
  dateFrom: null,
  dateTo: null,
};

export const ACTION_OPTIONS = [
  { value: "accepted", label: "Камера акцептована" },
  { value: "deaccepted", label: "Камера деакцептована" },
  { value: "camera_added", label: "Камера добавлена" },
  { value: "camera_removed", label: "Камера удалена" },
  { value: "camera_moved", label: "Камера перемещена" },
  { value: "camera_renamed", label: "Камера переименована" },
  { value: "camera_offline", label: "Камера оффлайн" },
];

export const ZONE_OPTIONS = [
  { value: "sales", label: "Продажи" },
  { value: "service", label: "Сервис" },
];
